import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import * as PermissionsConstants from "../../const/constants";
import { ABECASUSER_LOGIN_TYPE, CARRIER_LOGIN_TYPE } from "../../common/permissions";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import TextBox from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import AutoCompleteComponent from '../../om/services/AutoCompleteComponent'
import DateBox from 'devextreme-react/date-box';
import { CONSIGNEE_ID_FROM, CONSIGNEE_ID_TO, SHIPPER_ID_FROM, SHIPPER_ID_TO, CUSTOMER_ID_FROM, CUSTOMER_ID_TO } from "./consignee/TransactionIdLookupWithNewStyle";
import DataSource from 'devextreme/data/data_source';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import FormField from "../../dynamicFormBuilder/FormField";
import data from "../../assets/apiRoutes.json";
import { buildDxFilters, getAppSettings, loadLookupFromStaticDataSource } from "../../common/Utils";
import { SearchLayout } from "./Layout";
import { TransactionTypes } from "../../const/Lookup";
import { Statuses } from "../../enum/Enum";

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const TransactionFormField = (props) => {
  let showOnlyShippersAttachedToCustomer = false;
  let showOnlyConsigneeAttachedToCustomers = false;
  var accessToken = props.oidc.user.access_token;
  const [searchPanelStatus, setSearchPanelStatus] = React.useState(getAppSettings()?.FiltersCollapsed? false : true);

  const initialFormFields = {
    Pallets: null,
    Status: null,
    Stage: null,
    StageFlag: null,
    Actualreceivedshippeddatetime: null,
    Carrier: null,
    CarrierName: null,
    Comment: null,
    Companyid: null,
    Consignee: null,
    ConsigneeAddress1: null,
    ConsigneeAddress2: null,
    ConsigneeAddressMemo: null,
    ConsigneeName: null,
    ConsigneeState: null,
    ConsigneeZip: null,
    Container: null,
    Customer: null,
    CustomerName: null,
    Equipmentinterchangereport: null,
    Freightchargetype: null,
    Shipper: null,
    ShipperAddress1: null,
    ShipperAddress2: null,
    ShipperAddressMemo: null,
    ShipperName: null,
    ShipperState: null,
    Shipperbolnumber: null,
    ShipperZip: null,
    Reference: null,
    Recordtype: null,
    TotalQuantityActual: null,
    TotalQuantityOrder: null,
    Transactiondate: null,
    Transactiongroup: null,
    Transactionnumber: null,
    Transactiontype:props.transactionType || 'R',
    TransportCarrier: null,
    TransportCarrierName: null,
    UserDefinedCode1: null,
    UserDefinedCode2: null,
    UserDefinedCode3: null,
    UserDefinedCode4: null,
    UserDefinedCode5: null,
    UserDefinedCode6: null,
    UserDefinedCode7: null,
    UserDefinedCode8: null,
    UserDefinedCode9: null,
    UserDefinedCode10: null,
    Userdefinedcomment: null,
    Userdefineddate1: null,
    Userdefineddate2: null,
    Userdefineddate3: null,
    Userdefineddate4: null,
    Userdefineddate5: null,
    Userdefineddate6: null,
    Userdefineddate7: null,
    Userdefineddate8: null,
    Userdefineddate9: null,
    Userdefineddate10: null,
    Userdefinedquantity1: null,
    Userdefinedquantity2: null,
    Userdefinedquantity3: null,
    Userdefinedquantity4: null,
    Userdefinedquantity5: null,
    Userdefinedquantity6: null,
    Userdefinedquantity7: null,
    Userdefinedquantity8: null,
    Userdefinedquantity9: null,
    Userdefinedquantity10: null,
    Userdefinedreference1: null,
    Userdefinedreference2: null,
    Userdefinedreference3: null,
    Userdefinedreference4: null,
    Userdefinedreference5: null,
    Userdefinedreference6: null,
    Userdefinedreference7: null,
    Userdefinedreference8: null,
    Userdefinedreference9: null,
    Userdefinedreference10: null,
    Rowid: null,
    Sublotcount: null,
    TotalGrossWeight: null,
    TotalNetWeight: null,
    Plannedreceivedshippeddatetime: null,
    RCustomer: null,
    IsAssociatedCustomerTrans: null,
    CreationDateTime: null,
    CreationUserId: null,
    LastUpdateDateTime: null,
    LastUpdateUserId: null,
    Module: null,
    TransportationMode: null,
    TruckReference: null,
    TruckArrivalDateTime: null,
    TruckDepartDateTime: null,
    DeliveryPickupFlag: null,
    DeliveryPickupDepartDateTime: null,
    DispatchOrderNumber: null,
    ThirdPartyBillType: null,
    ConsolidateInvoiceFlag: null,
    PickStatus: null,
    FreightAmount: null,
    CodAmount: null,
    CodAmountCollected: null,
    CodCollectionDateTime: null,
    CodPayMethod: null,
    TaxBasis: null,
    TaxRate: null,
    TaxAmount: null,
    PrintReceipt: null,
    PrintBol: null,
    PrintLabel: null,
    SendFax: null,
    FiscalYear: null,
    FiscalPeriod: null,
    CommitDate: null,
    HoldReason: null,
    ConsolidatedInvoice: null,
    TransferToDispatch: null,
    RCodPayor: null,
    RCodPayee: null,
    RFreightBillTo: null,
    RArOpenItemHeader: null,
    RStagingWarehouse: null,
    RStagingArea: null,
    RTaxCode: null,
    RThirdPartyCustomer: null,
    RThirdPartyFreightBillTo: null,
    RFreightBillNumber: null,
    RAgent: null,
    RCarrier: null,
    RDriver: null,
    RConsignee: null,
    RShipper: null,
    RProfile: null,
    FmTruckReference: null,
    FmTrailerRReference: null,
    FmDriverReference: null,
    TransportationYardLeaveDate: null,
    DeliveryPickupPlannedDateTime: null,
    DeliveryPickupArrivedDateTime: null,
    PlanResourcesCode: null,
    PlanResourcesHours: null,
    PlanReference: null,
    PlanComment: null,
    StagingStartDate: null,
    StagingEndDate: null,
    UnloadPickByPlanDate: null,
    CheckByPlanDate: null,
    PutAwayByPlanDate: null,
    EditTransmitCustomer: null,
    EditTransmitShipper: null,
    EditTransmitConsignee: null,
    EditTransmitCarrier: null,
    EquipmentType: null,
    TransactionNumberFrom: null,
    TransactionDateFrom: null,
    TransactionDateTo: null,
    CustomerNameFrom: null,
    CustomerNameTo: null,
    ConsigneeNameFrom: null,
    ConsigneeNameTo: null,
    ShipperNameFrom: null,
    ShipperNameTo: null,
  };
  const [formFields, setformFields] = useState(initialFormFields);
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});

  const handleSearch = async (e) => {
    e.event.stopPropagation();
    let dataSource = loadData(formFields);
    props.searchData(dataSource);
  }
  const selectionChanged = useCallback(
    (e) => {
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        props.setSearchPanelStatus(newStatus);
        return newStatus;
      });
    },
    [props.setSearchPanelStatus],
  );
  const resetReceiptQueryForm = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
    let dataSource = loadData(initialFormFields);
    props.searchData(dataSource);
  };

  const { rolePermissions } = props.ReceiptReducer;
  const checkUserPermissions = () => {
    if (rolePermissions) {
      if (rolePermissions[PermissionsConstants.TransactionReceipt] && Array.isArray(rolePermissions[PermissionsConstants.TransactionReceipt])) {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionReceipt].length; i++) {
          var perm = PermissionsConstants.TransactionReceipt + rolePermissions[PermissionsConstants.TransactionReceipt][i];

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyShippersAttachedToCustomer) {
            showOnlyShippersAttachedToCustomer = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyConsigneeAttachedToCustomers) {
            showOnlyConsigneeAttachedToCustomers = true;
          }
        }
      }
    }
  };

  useEffect(() => {
    checkUserPermissions();
    // DEV-6022: Temporarily commented
    const isLoadDataOnPageLoad = getAppSettings()?.LoadGridOnPageLoad ?? false;
    if(isLoadDataOnPageLoad){
    let dataSource = loadData(initialFormFields);
    props.searchData(dataSource);
    }
  }, []);
  const loadData = (fields) => {
    const filters = buildDxFilters(fields, SearchLayout);
    if(props.statusFlag === Statuses.History)
      filters.push(['StatusFlag', '=', props.statusFlag]);
    else
      filters.push(['StatusFlag', '<>', Statuses.History]);
    let datasource = loadDatasource();
    datasource.filter(filters);
    return datasource;
  }
  const loadDatasource = () => {
    let store = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchTransactionWithServerSidePaging}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });

    const dataSource = new DataSource({ store: store });
    return dataSource;
  };
  const onFormLoad = () => {
     loadLookupFromStaticDataSource("Transactiontype",TransactionTypes,formFields,formRefs);
  }
  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >
            <AccordionReact
              dataSource={searchpanel}
              collapsible={true}
              multiple={false}
              animationDuration={300}
              onSelectionChanged={selectionChanged}
              defaultSelectedIndex={getAppSettings()?.FiltersCollapsed ? -1 : 0}
              itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                  <Item location="before">
                    <div className="title">
                      <h6
                        style={{
                          color: window._env_.Color2
                        }}
                      >
                        {props.permission ===
                          PermissionsConstants.TransactionReceipt
                          ? "Enter Your Query For Receipts"
                          : props.permission ===
                            PermissionsConstants.TransactionAdjustment
                            ? "Enter Your Query For Adjustments"
                            : "Enter Your Query For Shipments"}
                      </h6>
                    </div>
                  </Item>

                  <Item location="after">
                    <Button className="gridTopButton" text="Search" onClick={handleSearch} type="default"></Button>
                  </Item>
                  <Item location="after">
                    <Button className="gridTopButton" onClick={(e) => resetReceiptQueryForm(e)} text="Reset" />
                  </Item>
                </Toolbar>
              )}
              itemRender={(itemProps) => (
                <FormField
                  currrentUser={currentUser}
                  layoutId='DC494482-C29B-4061-8B47-B67A054BF65F'
                  layoutName='WMCustomerTransDataEntrySearchForm'
                  defaultFormSchema={SearchLayout}
                  formFields={formFields}
                  setformFields={setformFields}
                  handleFieldValueChange={() => { }}
                  DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                  formRefs={formRefs}
                  onFormLoad={onFormLoad}
                />
              )}
              id="accordion-container" className="accordion-height"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionFormField);